import { Typography } from '@material-ui/core'
import * as React from 'react'

import GameType from 'data/games/gameTypes'
import ReactSVG from 'react-svg'
import { getColorInGradient } from 'services/colors'
import { getGameImage, getGameTitle } from 'services/games'
import './styles.scss'

interface IProps {
  type: GameType
  fullCount?: number
  completed?: number
  headerText?: string
  onClick?: () => void
  fault?: boolean
}

interface IState {}

export class GameBox extends React.Component<IProps, IState> {
  startColor = '#5217B2'
  endColor = '#FF20E9'

  hasData = () => {
    const { completed, fullCount } = this.props
    return completed !== undefined && fullCount !== undefined
  }

  getDefaultHeader = () => {
    const { completed, fullCount, headerText } = this.props

    return headerText ? (
      <Typography className="game-header">{headerText}</Typography>
    ) : (
      <Typography
        className={`game-header score ${
          completed! < fullCount! ? 'un' : ''
        }completed`}
      >
        {completed}/{fullCount}
      </Typography>
    )
  }

  renderHeaderContent = () => {
    const { type } = this.props
    switch (type) {
      case GameType.attention:
      case GameType.math:
      case GameType.memory:
      case GameType.spatial:
        return this.getDefaultHeader()
      default:
        return null
    }
  }

  renderMainContent = () => {
    const { type } = this.props
    return (
      <>
        <div className="illustration-container">
          <ReactSVG src={getGameImage(type)} className="illustration" />
        </div>
        <Typography className="title">{getGameTitle(type)}</Typography>
      </>
    )
  }

  renderFooterContent = () => {
    const { completed, fullCount } = this.props
    const base = 100
    const overlayWidth = (completed! / fullCount!) * base
    return (
      <div className="progress">
        {this.hasData() ? (
          <div
            className={`progress-overlay ${
              completed! < fullCount! ? 'un' : ''
            }completed`}
            style={{
              width: `${overlayWidth}%`,
              backgroundImage: `linear-gradient(90deg, ${
                this.startColor
              }, ${getColorInGradient(
                overlayWidth,
                this.startColor,
                this.endColor
              )})`
            }}
          />
        ) : null}
      </div>
    )
  }

  render() {
    const { onClick } = this.props
    return (
      <div className="game-box" onClick={onClick}>
        <div className="game-box-header">{this.renderHeaderContent()}</div>
        <div className="game-box-main">{this.renderMainContent()}</div>
        <div className="game-box-footer">{this.renderFooterContent()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/GameBox/index.tsx